import React, { useState, useEffect } from 'react';
import './Pages.css';

const NewExtensions = ({ setActiveMenu }) => {
  const [extensions, setExtensions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    fetchNewExtensions();
  }, []);

  const fetchNewExtensions = async () => {
    try {
      const response = await fetch('https://main.victriedemos.com:3017/api/extensions/status/0');
      const data = await response.json();

      if (data.success) {
        setExtensions(data.data);
      } else {
        setError('Failed to load new extensions');
      }
    } catch (err) {
      console.error('Error fetching new extensions:', err);
      setError('Unable to connect to server');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return 'N/A';
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  const formatCurrency = (amount) => {
    if (!amount) return 'N/A';
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES'
    }).format(amount);
  };

  const handleForwardForApproval = async (extension) => {
    if (!window.confirm(`Forward extension for policy ${extension.PolicyNumber} for approval?`)) {
      return;
    }

    try {
      const userEmail = localStorage.getItem('userEmail');
      
      const response = await fetch('https://main.victriedemos.com:3017/api/extensions/forward-approval', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          extensionId: extension.Id,
          forwardedBy: userEmail
        })
      });

      const data = await response.json();

      if (data.success) {
        alert('✅ Extension forwarded for approval successfully!');
        fetchNewExtensions();
      } else {
        alert('❌ Failed to forward extension: ' + data.message);
      }
    } catch (err) {
      console.error('Error forwarding extension:', err);
      alert('❌ An error occurred while forwarding extension');
    }
  };

  const filteredExtensions = extensions.filter(ext => {
    if (!searchTerm) return true;
    
    const search = searchTerm.toLowerCase();
    const policyNumber = (ext.PolicyNumber || '').toLowerCase();
    const registration = (ext.Registration || '').toLowerCase();
    
    return policyNumber.includes(search) || registration.includes(search);
  });

  if (loading) {
    return (
      <div className="page-container">
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading new extensions...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1>📝 New Extensions</h1>
          <p className="page-subtitle">Extensions pending submission for approval</p>
        </div>
        <div className="badge-count">{filteredExtensions.length} Extensions</div>
      </div>

      {error && (
        <div className="error-banner">
          {error}
        </div>
      )}

      <div className="search-bar">
        <input
          type="text"
          placeholder="🔍 Search by Policy Number or Registration..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        {searchTerm && (
          <button 
            className="clear-search-btn"
            onClick={() => setSearchTerm('')}
          >
            ✕ Clear
          </button>
        )}
      </div>

      <div className="table-container">
        {filteredExtensions.length === 0 ? (
          <div className="empty-state">
            <p>{searchTerm ? `No extensions found matching "${searchTerm}"` : 'No new extensions found'}</p>
          </div>
        ) : (
          <table className="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Policy Number</th>
                <th>Registration</th>
                <th>Commencement Date</th>
                <th>Expiry Date</th>
                <th>Gross Premium</th>
                <th>Date Created</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredExtensions.map((ext, index) => (
                <tr key={ext.Id}>
                  <td>{index + 1}</td>
                  <td className="policy-number">{ext.PolicyNumber || 'N/A'}</td>
                  <td>{ext.Registration || 'N/A'}</td>
                  <td>{formatDate(ext.CommencementDate)}</td>
                  <td>{formatDate(ext.ExpiryDate)}</td>
                  <td className="amount">{formatCurrency(ext.GrossPremium)}</td>
                  <td>{formatDate(ext.DateDone)}</td>
                  <td>
                    <button 
                      className="action-icon-btn approve-btn" 
                      title="Forward for Approval"
                      onClick={() => handleForwardForApproval(ext)}
                    >
                      ➡️
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default NewExtensions;
